import { getByKey, save } from '@/api/administration/adminTable.js'

const defaultState  = () => {
  return {
    list: []
  }
}
const adminTable = {
  namespaced: true,
  state: defaultState(),
  mutations:{
    // RESET_ADMIN_TABLE:(state) => {
    //   Object.assign(state, defaultState())
    // },
    SET_ADMIN_TABLE: (state, connect) => {
      state.list = []
      connect.forEach((element) => {
        state.list.push({
          id: element.id,
          type: element.key_admin,
          value: element.value_admin,
          terms: (element.terms) ? element.terms : null,
          parent: element.parent,
        });
      });
    },
  },
  actions:{
    async getByKey({ commit, state }, keyAdmin){
      try {
        let data = await getByKey(keyAdmin)
        commit('SET_ADMIN_TABLE', data.data)
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al consultar.'}, { root: true})
      }
    },
    async save({ commit, state, dispatch }, data){
      try {
        await save(data.key, data.value, data.parent, data.terms)
        dispatch('getByKey', data.key)
        commit('SET_RESPONSE', {type: 'success', msg: 'Guardado.'}, { root: true})
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al guardar.'}, { root: true})
      }
    },
  },
}

export default adminTable